import gql from 'graphql-tag'

export const eventCodeAssignCoreCause = gql`
  mutation eventCodeAssignCoreCause($eventCodeId: ID!, $coreCauseId: ID!) {
    eventCodeAssignCoreCause(input: { eventCodeId: $eventCodeId, coreCauseId: $coreCauseId }) {
      success
    }
  }
`
